export const Marquee = ({ items = [] }) => (
  <div
    className="relative w-full max-w-full overflow-hidden bg-cts-ink py-4 box-border"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    {/* Desktop (>=1024px): full static row, single copy, no animation, guaranteed to fit */}
    <div className="hidden lg:flex container-site items-center justify-center flex-nowrap">
      {items.map((item, i) => (
        <span key={item} className="flex items-center shrink-0 font-mono font-medium text-[10px] tracking-[0.12em] uppercase text-white/70 whitespace-nowrap">
          {item}
          {i < items.length - 1 && <span className="mx-3 w-1.5 h-1.5 rounded-full bg-cts-red inline-block shrink-0" />}
        </span>
      ))}
    </div>

    {/* Tablet & mobile (<1024px): contained scrolling marquee */}
    <div className="lg:hidden inline-flex w-max whitespace-nowrap animate-marquee will-change-transform">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center shrink-0 font-mono font-medium text-[11px] tracking-[0.22em] uppercase text-white/70 mx-6">
          {item}
          <span className="mx-6 w-1.5 h-1.5 rounded-full bg-cts-red inline-block shrink-0" />
        </span>
      ))}
    </div>
  </div>
);
